const MirLogo = () => (
  <svg fill="none" height="24" viewBox="0 0 36 24" width="36" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 6.40024C0 4.16003 0 3.03993 0.435974 2.18428C0.819467 1.43163 1.43139 0.819712 2.18404 0.436218C3.03968 0.000244141 4.15979 0.000244141 6.4 0.000244141H29.6C31.8402 0.000244141 32.9603 0.000244141 33.816 0.436218C34.5686 0.819712 35.1805 1.43163 35.564 2.18428C36 3.03993 36 4.16003 36 6.40024V17.6002C36 19.8405 36 20.9606 35.564 21.8162C35.1805 22.5689 34.5686 23.1808 33.816 23.5643C32.9603 24.0002 31.8402 24.0002 29.6 24.0002H6.4C4.15979 24.0002 3.03968 24.0002 2.18404 23.5643C1.43139 23.1808 0.819467 22.5689 0.435974 21.8162C0 20.9606 0 19.8405 0 17.6002V6.40024Z"
      fill="white"
    />
    <path clipRule="evenodd" d="M18.439 16.6918H21.2935V7.5907H18.439V16.6918Z" fill="#3CA436" fillRule="evenodd" />
    <path
      clipRule="evenodd"
      d="M31.4878 16.6931L29.4628 13.6117C30.3231 13.2971 31.0044 12.6033 31.31 11.7277H22.5166V16.692H25.3654V13.7961H26.7296L28.2255 16.6931H31.4878Z"
      fill="#3CA436"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M22.1089 7.5907C22.4924 9.70858 24.3194 11.3139 26.5179 11.3139V11.3139H31.4264C31.4664 11.1134 31.4879 10.9059 31.4879 10.6934V10.6934C31.4879 8.9799 30.1185 7.5907 28.4295 7.5907V7.5907H22.1089Z"
      fill="#3CA436"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.7499 8.73119L11.557 12.9557H11.3525L10.1596 8.73119C9.95751 8.01555 9.31645 7.52283 8.58735 7.52283H5.72754V16.7171H8.5911V11.2841H8.7956L10.432 16.7171H12.4775L14.1139 11.2841H14.3184V16.7171H17.1821V7.52283H14.3221C13.5932 7.52283 12.952 8.01555 12.7499 8.73119"
      fill="#3CA436"
      fillRule="evenodd"
    />
    <rect height="23.5" rx="3.75" stroke="black" strokeWidth="0.5" width="35.5" x="0.25" y="0.250244" />
  </svg>
)

export default MirLogo
